const academic = () => import('../views/academic-menu/review')
const academicDetail = () => import('../views/academic-menu/review/detail')
// const manuscripts = () => import('../views/academic-menu/manuscripts')
// const manuscriptsDetail = () =>
//   import('../views/academic-menu/manuscripts/detail')

const path = '/academic-menu'

export default [
  {
    path: path + '/academic',
    component: academic,
    name: '/academic-menu/academic'
  },
  {
    path: path + '/academic/submit/:type/:id',
    component: academicDetail,
    name: '/academic-menu/academic/submit'
  },
  {
    path: path + '/academic/detail/:type/:id',
    component: academicDetail,
    name: '/academic-menu/academic/detail'
  }
  // {
  //   path: path + '/manuscripts',
  //   component: manuscripts,
  //   name: '/academic-menu/manuscripts'
  // },
  // {
  //   path: path + '/manuscripts/detail/:id',
  //   component: manuscriptsDetail,
  //   name: '/academic-menu/manuscripts/detail/:id'
  // }
]
